/**
 * Implements functionality for buttons that the user can use to clear selected filters in faceted
 * search.
 */
(() => {
    let form = document.querySelector('.js-faceted-search-form');

    if (!form) {
        return;
    }

    function clearKeyword(button, name) {
        let input = form.querySelector("input[name='" + name + "']");

        if (!input) {
            return;
        }

        input.value = input.value
            .replaceAll(button.getAttribute('data-value'), '')
            .trim()
            .replaceAll('  ', ' ')
            .replaceAll('  ', ' ');
        form.dispatchEvent(new Event('input'));
    }

    function clearInput(button, name) {
        const value = button.getAttribute('data-value');

        if (!value) {
            return;
        }

        let input = form.querySelector(
            "input[name='" + name + "'][value='" + value + "']"
        );

        if (!input) {
            return;
        }

        if (['checkbox', 'radio'].includes(input.type)) {
            input.checked = false;
        } else if (['text'].includes(input.type)) {
            input.value = '';
        } else {
            return;
        }

        input.dispatchEvent(new Event('change'));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function onClick(e) {
        // console.log('Button was pressed');

        e.preventDefault();

        H_Tools.preselect.disable();

        let button = e.currentTarget.closest('.js-faceted-search-clear-button');

        const name = button.getAttribute('data-name');

        if (!name) {
            return;
        }

        if (name === faceted_search.text_query_name) {
            clearKeyword(button, name);
        } else {
            clearInput(button, name);
        }
        H_Tools?.search?.showResults();
    }

    function clearAll(e) {
        // console.log('Clear all button pressed...');

        e.preventDefault();

        H_Tools.preselect.disable();

        let changed = false;

        document
            .querySelectorAll(
                '.js-faceted-search-filters input:is([type=checkbox], input[type=radio])'
            )
            .forEach((input) => {
                if (!input.checked) {
                    return;
                }
                input.checked = false;
                input.dispatchEvent(new Event('change'));
                changed = true;
            });

        document
            .querySelectorAll(
                '.js-faceted-search-text-field, .js-faceted-search-filters input:is([type=text])'
            )
            .forEach((input) => {
                if (input.value === '') {
                    return;
                }
                input.value = '';
                input.dispatchEvent(new Event('input'));
                changed = true;
            });

        if (!changed) {
            return;
        }

        form.dispatchEvent(new Event('input'));

        // if this 'clear all' button is inside search results
        if (
            H_Tools.ancestors.getAllAncestors(
                e.currentTarget,
                form,
                'js-faceted-search-results'
            ).length !== 0
        ) {
            H_Tools?.search?.showResults();
        }
    }

    /**
     * Adds listeners for all clear buttons inside the supplied element.
     *
     * @param {*} el An element to query for clear buttons
     */
    function addListeners(el) {
        if (!el) {
            return;
        }

        // listeners for "Clear all" buttons
        el.querySelectorAll('.js-faceted-search-clear-all-button').forEach(
            (button) => {
                button.addEventListener('click', clearAll);
            }
        );

        // listeners for buttons that clear an invidual facet value
        el.querySelectorAll('.js-faceted-search-clear-button').forEach(
            (button) => {
                button.addEventListener('click', onClick);
            }
        );
    }

    form.addEventListener('htmx:afterSettle', (e) => {
        addListeners(form.querySelector('.js-faceted-search-results'));
    });

    addListeners(form);
})();
